import axios from "axios";
import { baseURL } from "./constants";

let accessToken: string | undefined;

export const setAccessTokenForInterceptor = (token: string | undefined) => {
  accessToken = token;
};

const axiosInstance = axios.create({
  baseURL,
  withCredentials: true,
});


axiosInstance.interceptors.request.use(
    (config: any) => {
      config.headers = {
        ...(config.headers || {}),
        ...(accessToken && { Authorization: `Bearer ${accessToken}` }),
        Accept: "application/json",
        "Content-Type": "application/json",
      };
      return config;
    },
    (error) => Promise.reject(error)
  );

export default axiosInstance;
